<script  module>
  import AppLayout from '$lib/layouts/AppLayout.svelte'
  export const layout = AppLayout
</script>

<script lang="ts">
  import { router, usePage } from "@inertiajs/svelte";
  import { 
    Plus, Settings2, ExternalLink, MousePointer2, 
    Globe2, Layers, CheckCircle2 
  } from "lucide-svelte";
  import { toast } from "svelte-sonner";

  const page = usePage();
  const domainSuffix = $derived(page.props.frontend_domain_suffix);
  
  // 接收后端解耦出来的字典对象 t
  let { sites = [], current_site_id = null, t = {} as any } = $props();

  // 切换站点逻辑
  function handleSwitch(siteId: number) {
    router.post('/sites/switch', { site_id: siteId }, {
      preserveScroll: true
    });
  }

  // 进入编辑逻辑
  function handleEdit(siteId: number) {
    router.get(`/sites/${siteId}/edit`);
  }
</script>

<div class="min-h-screen bg-gray-50/50 p-8 text-zinc-600 font-sans">
  <div class="max-w-6xl mx-auto">
    <header class="flex justify-between items-center mb-10 border-b border-gray-100 pb-8">
      <div>
        <h1 class="text-2xl font-bold text-zinc-950 flex items-center gap-3">
          <Layers class="size-6 text-blue-600" /> {t.title}
        </h1>
        <p class="text-xs text-zinc-500 mt-1 uppercase tracking-widest font-medium">
          {t.subtitle}
        </p>
      </div>
      
      <button 
        onclick={() => router.get('/sites/new')}
        class="bg-zinc-900 hover:bg-zinc-800 text-white px-5 py-2.5 rounded-xl text-xs font-bold transition-all flex items-center gap-2 shadow-lg shadow-zinc-950/5"
      >
        <Plus class="size-4" /> {t.btn_new}
      </button>
    </header>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {#each sites as site}
        <div 
          class="group relative bg-white border border-gray-100 rounded-3xl p-7 transition-all hover:border-blue-100 hover:shadow-xl hover:shadow-blue-500/5 overflow-hidden"
        >
          {#if site.id === current_site_id}
            <div class="absolute -top-3 -right-3 bg-blue-50 text-blue-600 text-[10px] font-bold px-3 py-1 rounded-full flex items-center gap-1 border border-blue-100 shadow-sm">
              <CheckCircle2 class="size-3" /> {t.active_status}
            </div>
          {/if}

          <div class="flex items-start justify-between mb-6">
            <div 
              class="size-14 rounded-2xl flex items-center justify-center text-white font-bold text-2xl shadow-inner border border-black/5"
              style="background-color: {site.appearance?.primary_color || '#3b82f6'}"
            >
              {site.name ? site.name.charAt(0) : 'S'}
            </div>
            <div class="flex gap-1">
              <button 
                onclick={() => handleEdit(site.id)}
                class="p-2.5 hover:bg-gray-100 rounded-lg text-gray-400 hover:text-zinc-900 transition-colors"
              >
                <Settings2 class="size-4" />
              </button>
              <a 
                href="https://{site.subdomain}.{domainSuffix}" 
                target="_blank"
                class="p-2.5 hover:bg-gray-100 rounded-lg text-gray-400 hover:text-zinc-900 transition-colors"
              >
                <ExternalLink class="size-4" />
              </a>
            </div>
          </div>

          <div class="space-y-1.5 mb-8">
            <h3 class="text-zinc-950 font-bold text-xl leading-snug">{site.name}</h3>
            <div class="flex items-center gap-1.5 text-zinc-500 font-mono text-[11px] bg-gray-100 px-2 py-0.5 rounded w-fit">
              <Globe2 class="size-3" />
              {site.subdomain}.{ domainSuffix }
            </div>
          </div>

          <div class="pt-5 border-t border-gray-100 flex items-center justify-between">
            <div class="flex -space-x-1.5">
              {#each (site.supported_locales || []) as loc}
                <div class="size-6 rounded-full bg-gray-100 border-2 border-white text-[9px] flex items-center justify-center font-bold text-zinc-500 uppercase">
                  {loc}
                </div>
              {/each}
            </div>

            {#if site.id !== current_site_id}
              <button 
                onclick={() => handleSwitch(site.id)}
                class="flex items-center gap-2 text-[11px] font-bold text-blue-600 hover:text-blue-700 transition-colors bg-blue-50 px-4 py-1.5 rounded-full"
              >
                <MousePointer2 class="size-3" /> {t.switch_workspace}
              </button>
            {:else}
              <span class="text-[11px] font-bold text-emerald-600 flex items-center gap-1.5">
                <span class="size-1.5 bg-emerald-500 rounded-full animate-pulse"></span>
                {t.managing}
              </span>
            {/if}
          </div>
        </div>
      {/each}
      
      <button 
        onclick={() => router.get('/sites/new')}
        class="border-2 border-dashed border-gray-200 rounded-3xl flex flex-col items-center justify-center p-10 hover:border-gray-300 hover:bg-gray-100/50 transition-all group min-h-[280px]"
      >
        <div class="size-12 rounded-full bg-gray-100 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform border border-gray-200">
          <Plus class="size-7 text-gray-400" />
        </div>
        <span class="text-xs font-bold text-gray-500 uppercase tracking-tight">{t.btn_add_card}</span>
      </button>
    </div>
  </div>
</div>

<style>
  :global(body) {
    background-color: #f9fafb !important;
  }
</style>